import AuthenticationServiceBaseClass from './authenticationService.base';
// import UserService from './restServices/userService';
import analyticsService from './analyticsService';
import {AuthRestService} from './restServices/restServices';
import scheduleUtils from '../components/scheduleComponents/scheduleUtils';
import jwtDecode from 'jwt-decode';

export default class AuthenticationService extends AuthenticationServiceBaseClass {
  doGmailLogin = (
    successCallbackFunction,
    loginFailCallbackFunction,
    registerAction,
    resellerToken,
    response,
  ) => {
    // var popupMessage = 'Your browser has blocked the Google popup. Please enable popups in order to login with Google';
    // if(popupsHandlerService.isPopupBlockerEnabled(popupMessage)){

    // GoogleAuthService.startGoogleLogin((response) => {
    const decodedResponse = jwtDecode(response.credential);
    var par = {
      idToken: response.credential,
      firstName: decodedResponse.given_name,
      lastName: decodedResponse.family_name,
      email: decodedResponse.email,
    };
    if (resellerToken && resellerToken !== '') {
      par.resellerToken = resellerToken;
    }
    if (registerAction === 'register') {
      const {
        marketingParameterAvailable,
        marketingParameterDto,
        partnerAffiliateId,
      } = analyticsService.getMarketingParametersForRegistration();
      par.marketingParameterAvailable = marketingParameterAvailable;
      par.marketingParameterDto = marketingParameterDto;
      par.partnerAffiliateId = partnerAffiliateId;
      par.timezone = scheduleUtils.generateGuessedTimezone();
    }
    AuthRestService.save(
      {
        endpoint:
          registerAction === 'register' ? 'googleRegister' : 'googleLogin',
      },
      par,
      (resource) => {
        this.loginSuccessFunction(resource, successCallbackFunction);
      }, // success
      (response) => {
        // failure
        //if (VIDABOO_CONSTANTS.TEST_ENV) {debugger};
        // console.debug(response.data);
        loginFailCallbackFunction(response.data);
        // this.logout();
      },
    );
    // });
    // }
  };
}
